import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div
  data-reviewable-id={{this.reviewable.id}}
  class="reviewable-item {{this.customClasses}}"
>
  <div class="reviewable-meta-data">
    <span
      class={{concat-class "reviewable-type" this.reviewable.humanTypeCssClass}}
    >{{this.reviewable.humanType}}</span>
    {{#if this.reviewable.reply_count}}
      <span class="reply-count">{{i18n
          "review.replies"
          count=this.reviewable.reply_count
        }}</span>
    {{/if}}
    <span class="created-at">
      <LinkTo
        @route="review.show"
        @model={{this.reviewable.id}}
      >{{age-with-tooltip this.reviewable.created_at}}</LinkTo>
    </span>
    <span class="status">
      {{reviewable-status this.reviewable.status this.reviewable.type}}
    </span>
    <a
      href
      {{on "click" (fn this.explainReviewable this.reviewable)}}
      title={{i18n "review.explain.why"}}
      class="explain"
    >
      {{d-icon "question-circle"}}
    </a>
  </div>

  <div class="reviewable-contents">
    {{#if this.editing}}
      <div class="editable-fields">
        {{#if this.reviewable.created_by}}
          <div class="editable-created-by">
            {{avatar this.reviewable.created_by imageSize="tiny"}}
            <ReviewableCreatedByName
              @user={{this.reviewable.created_by}}
              @tagName=""
            />
          </div>
        {{/if}}

        {{#each this.reviewable.editable_fields as |f|}}
          <div class="editable-field {{dasherize f.id}}">
            {{component
              (concat "reviewable-field-" f.type)
              tagName=""
              value=(editable-value this.reviewable f.id)
              tagCategoryId=this.tagCategoryId
              valueChanged=(action "valueChanged" f.id)
              categoryChanged=(action "categoryChanged")
            }}
          </div>
        {{/each}}
      </div>
    {{else}}
      {{#component
        this.reviewableComponent reviewable=this.reviewable tagName=""
      }}
        <ReviewableScores @reviewable={{this.reviewable}} @tagName="" />
      {{/component}}
    {{/if}}
  </div>

  {{#if this.displayContextQuestion}}
    <h3 class="reviewable-item__context-question">
      {{this.reviewable.flaggedReviewableContextQuestion}}
    </h3>
  {{/if}}

  <div class="reviewable-actions">
    {{#if this.reviewable.last_performing_username}}
      <div class="stale-help">{{html-safe
          (i18n
            "review.stale_help"
            username=this.reviewable.last_performing_username
          )
        }}</div>
    {{else}}
      {{#if this.claimEnabled}}
        <div class="claimed-actions">
          <span class="help">{{html-safe this.claimHelp}}</span>
          <ReviewableClaimedTopic
            @topicId={{this.topicId}}
            @claimedBy={{this.reviewable.claimed_by}}
          />
        </div>
      {{/if}}

      {{#if this.canPerform}}
        {{#if this.editing}}
          <DButton
            @disabled={{this.disabled}}
            @icon="check"
            @action={{action "saveEdit"}}
            @label="review.save"
            class="btn-primary reviewable-action save-edit"
          />
          <DButton
            @disabled={{this.disabled}}
            @icon="times"
            @action={{action "cancelEdit"}}
            @label="review.cancel"
            class="btn-danger reviewable-action cancel-edit"
          />
        {{else}}
          {{#each this.reviewable.bundled_actions as |bundle|}}
            <ReviewableBundledAction
              @bundle={{bundle}}
              @performAction={{action "perform"}}
              @reviewableUpdating={{this.disabled}}
            />
          {{/each}}

          {{#if this.reviewable.can_edit}}
            <DButton
              @disabled={{this.disabled}}
              @icon="pencil-alt"
              @action={{action "edit"}}
              @label="review.edit"
              class="reviewable-action btn-default edit"
            />
          {{/if}}
        {{/if}}
      {{/if}}
    {{/if}}
    <PluginOutlet
      @name="reviewable-item-actions"
      @connectorTagName="div"
      @outletArgs={{hash reviewable=this.reviewable}}
    />
  </div>
</div>
*/
{
  "id": "yIQu0RdV",
  "block": "[[[10,0],[15,\"data-reviewable-id\",[30,0,[\"reviewable\",\"id\"]]],[15,0,[29,[\"reviewable-item \",[30,0,[\"customClasses\"]]]]],[12],[1,\"\\n  \"],[10,0],[14,0,\"reviewable-meta-data\"],[12],[1,\"\\n    \"],[10,1],[15,0,[28,[37,0],[\"reviewable-type\",[30,0,[\"reviewable\",\"humanTypeCssClass\"]]],null]],[12],[1,[30,0,[\"reviewable\",\"humanType\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"reviewable\",\"reply_count\"]],[[[1,\"      \"],[10,1],[14,0,\"reply-count\"],[12],[1,[28,[35,2],[\"review.replies\"],[[\"count\"],[[30,0,[\"reviewable\",\"reply_count\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,1],[14,0,\"created-at\"],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@route\",\"@model\"],[\"review.show\",[30,0,[\"reviewable\",\"id\"]]]],[[\"default\"],[[[[1,[28,[35,4],[[30,0,[\"reviewable\",\"created_at\"]]],null]]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"status\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[[30,0,[\"reviewable\",\"status\"]],[30,0,[\"reviewable\",\"type\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,3],[24,6,\"\"],[16,\"title\",[28,[37,2],[\"review.explain.why\"],null]],[24,0,\"explain\"],[4,[38,6],[\"click\",[28,[37,7],[[30,0,[\"explainReviewable\"]],[30,0,[\"reviewable\"]]],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,8],[\"question-circle\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"reviewable-contents\"],[12],[1,\"\\n\"],[41,[30,0,[\"editing\"]],[[[1,\"      \"],[10,0],[14,0,\"editable-fields\"],[12],[1,\"\\n\"],[41,[30,0,[\"reviewable\",\"created_by\"]],[[[1,\"          \"],[10,0],[14,0,\"editable-created-by\"],[12],[1,\"\\n            \"],[1,[28,[35,9],[[30,0,[\"reviewable\",\"created_by\"]]],[[\"imageSize\"],[\"tiny\"]]]],[1,\"\\n            \"],[8,[39,10],null,[[\"@user\",\"@tagName\"],[[30,0,[\"reviewable\",\"created_by\"]],\"\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[37,12],[[28,[37,12],[[30,0,[\"reviewable\",\"editable_fields\"]]],null]],null],null,[[[1,\"          \"],[10,0],[15,0,[29,[\"editable-field \",[28,[37,13],[[30,1,[\"id\"]]],null]]]],[12],[1,\"\\n            \"],[46,[28,[37,15],[\"reviewable-field-\",[30,1,[\"type\"]]],null],null,[[\"tagName\",\"value\",\"tagCategoryId\",\"valueChanged\",\"categoryChanged\"],[\"\",[28,[37,16],[[30,0,[\"reviewable\"]],[30,1,[\"id\"]]],null],[30,0,[\"tagCategoryId\"]],[28,[37,17],[[30,0],\"valueChanged\",[30,1,[\"id\"]]],null],[28,[37,17],[[30,0],\"categoryChanged\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[46,[30,0,[\"reviewableComponent\"]],null,[[\"reviewable\",\"tagName\"],[[30,0,[\"reviewable\"]],\"\"]],[[\"default\"],[[[[1,\"        \"],[8,[39,18],null,[[\"@reviewable\",\"@tagName\"],[[30,0,[\"reviewable\"]],\"\"]],null],[1,\"\\n\"]],[]]]]]],[]]],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"displayContextQuestion\"]],[[[1,\"    \"],[10,\"h3\"],[14,0,\"reviewable-item__context-question\"],[12],[1,\"\\n      \"],[1,[30,0,[\"reviewable\",\"flaggedReviewableContextQuestion\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"reviewable-actions\"],[12],[1,\"\\n\"],[41,[30,0,[\"reviewable\",\"last_performing_username\"]],[[[1,\"      \"],[10,0],[14,0,\"stale-help\"],[12],[1,[28,[35,19],[[28,[37,2],[\"review.stale_help\"],[[\"username\"],[[30,0,[\"reviewable\",\"last_performing_username\"]]]]]],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"claimEnabled\"]],[[[1,\"        \"],[10,0],[14,0,\"claimed-actions\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"help\"],[12],[1,[28,[35,19],[[30,0,[\"claimHelp\"]]],null]],[13],[1,\"\\n          \"],[8,[39,20],null,[[\"@topicId\",\"@claimedBy\"],[[30,0,[\"topicId\"]],[30,0,[\"reviewable\",\"claimed_by\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canPerform\"]],[[[41,[30,0,[\"editing\"]],[[[1,\"          \"],[8,[39,21],[[24,0,\"btn-primary reviewable-action save-edit\"]],[[\"@disabled\",\"@icon\",\"@action\",\"@label\"],[[30,0,[\"disabled\"]],\"check\",[28,[37,17],[[30,0],\"saveEdit\"],null],\"review.save\"]],null],[1,\"\\n          \"],[8,[39,21],[[24,0,\"btn-danger reviewable-action cancel-edit\"]],[[\"@disabled\",\"@icon\",\"@action\",\"@label\"],[[30,0,[\"disabled\"]],\"times\",[28,[37,17],[[30,0],\"cancelEdit\"],null],\"review.cancel\"]],null],[1,\"\\n\"]],[]],[[[42,[28,[37,12],[[28,[37,12],[[30,0,[\"reviewable\",\"bundled_actions\"]]],null]],null],null,[[[1,\"            \"],[8,[39,22],null,[[\"@bundle\",\"@performAction\",\"@reviewableUpdating\"],[[30,2],[28,[37,17],[[30,0],\"perform\"],null],[30,0,[\"disabled\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"\\n\"],[41,[30,0,[\"reviewable\",\"can_edit\"]],[[[1,\"            \"],[8,[39,21],[[24,0,\"reviewable-action btn-default edit\"]],[[\"@disabled\",\"@icon\",\"@action\",\"@label\"],[[30,0,[\"disabled\"]],\"pencil-alt\",[28,[37,17],[[30,0],\"edit\"],null],\"review.edit\"]],null],[1,\"\\n\"]],[]],null]],[]]]],[]],null]],[]]],[1,\"    \"],[8,[39,23],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"reviewable-item-actions\",\"div\",[28,[37,24],null,[[\"reviewable\"],[[30,0,[\"reviewable\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"f\",\"bundle\"],false,[\"concat-class\",\"if\",\"i18n\",\"link-to\",\"age-with-tooltip\",\"reviewable-status\",\"on\",\"fn\",\"d-icon\",\"avatar\",\"reviewable-created-by-name\",\"each\",\"-track-array\",\"dasherize\",\"component\",\"concat\",\"editable-value\",\"action\",\"reviewable-scores\",\"html-safe\",\"reviewable-claimed-topic\",\"d-button\",\"reviewable-bundled-action\",\"plugin-outlet\",\"hash\"]]",
  "moduleName": "discourse/components/reviewable-item.hbs",
  "isStrictMode": false
});